import { render, staticRenderFns } from "./ImportsTemplate.vue?vue&type=template&id=70f6bb61"
import script from "./ImportsTemplate.vue?vue&type=script&lang=js"
export * from "./ImportsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports